module.exports = __webpack_public_path__ + "img/landos-minus__list.png?018f32926c05ac14c7730ba23aa47188";